import axios from 'axios';

const HttpClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || 'http://localhost:3000',
  headers: {
    'Content-type': 'application/json',
  },
});

HttpClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (config.headers) {
    config.headers.Authorization = token ? `Bearer ${token}` : '';
  }
  return config;
});

export default HttpClient;
